import React, { useEffect, useState, useRef } from 'react';
export function AboutSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -40px 0px'
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section ref={sectionRef} className="bg-white text-black py-24 sm:py-32 md:py-40 px-6 sm:px-12 md:px-16 lg:px-24 overflow-hidden" id="about" data-id="element-1585" data-mp="8cptwcje4bi2">
      <div className="container mx-auto max-w-7xl" data-id="element-1586" data-mp="15teszygygznr">
        {/* Unified Section Header */}
        <div className="mb-16 sm:mb-24" style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
        transition: 'opacity 0.8s ease-out, transform 0.8s ease-out'
      }} data-id="element-1587" data-mp="10ysgtt31v32m">
          <div className="text-xs tracking-[0.3em] uppercase text-slate-500 font-medium mb-4" style={{
          fontFamily: "'Ronzino', sans-serif"
        }} data-id="element-1588" data-mp="2h6z2dx40dat1">
            ABOUT
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-light text-slate-900 leading-tight mb-6" style={{
          fontFamily: "'Gefika', sans-serif"
        }} data-id="element-1589" data-mp="2c8e07s574h1y">
            About Me
          </h2>
          <div className="w-12 h-px bg-slate-900" data-id="element-1590" data-mp="22aq879yz5nnh"></div>
        </div>

        <div className="flex flex-col lg:grid lg:grid-cols-12 lg:gap-16" style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
        transition: 'opacity 0.8s ease-out 0.15s, transform 0.8s ease-out 0.15s'
      }} data-id="element-1591" data-mp="3sme0j47ye8pq">
          {/* Left column with image and meta strip */}
          <div className="lg:col-span-5 mb-12 lg:mb-0" data-id="element-1592" data-mp="10eljw55u8464">
            <div className="bg-slate-50 border border-slate-200 rounded-2xl overflow-hidden aspect-[4/5] w-full max-w-sm" data-id="element-1593" data-mp="10h7rg4sqajoc">
              <img src="https://cdn.magicpatterns.com/uploads/8FN6MVYdTZWchFWY5AGpqb/9236f44f5ce18172.jpg" alt="Mateo Cohen portrait" className="w-full h-full object-cover" style={{
              objectPosition: 'center 20%'
            }} data-id="element-1594" data-mp="1s61fuptab390" />
            </div>

            {/* Meta Strip */}
            <div className="mt-6 grid grid-cols-3 gap-4 sm:gap-6 max-w-sm" data-id="element-1595" data-mp="1ecs78rd5ulrj">
              <div data-id="element-1596" data-mp="2bvtmqm0u5c86">
                <div className="text-[10px] tracking-[0.2em] uppercase text-slate-500 mb-2 font-medium" style={{
                fontFamily: "'Ronzino', sans-serif"
              }} data-id="element-1597" data-mp="2bwd3hzer1ukm">
                  Location
                </div>
                <div className="text-sm font-medium text-slate-900" style={{
                fontFamily: 'system-ui, -apple-system, sans-serif'
              }} data-id="element-1598" data-mp="2jfvxf0pj787z">
                  Ohio, USA
                </div>
              </div>
              <div data-id="element-1599" data-mp="2xdasom2gua7v">
                <div className="text-[10px] tracking-[0.2em] uppercase text-slate-500 mb-2 font-medium" style={{
                fontFamily: "'Ronzino', sans-serif"
              }} data-id="element-1600" data-mp="32cnnpu3hqnlj">
                  Currently
                </div>
                <div className="text-sm font-medium text-slate-900" style={{
                fontFamily: 'system-ui, -apple-system, sans-serif'
              }} data-id="element-1601" data-mp="3c49u9d4vvyhy">
                  Eli Lilly
                </div>
              </div>
              <div data-id="element-1602" data-mp="37e1y31lqu2qu">
                <div className="text-[10px] tracking-[0.2em] uppercase text-slate-500 mb-2 font-medium" style={{
                fontFamily: "'Ronzino', sans-serif"
              }} data-id="element-1603" data-mp="33f2vvoreck33">
                  Open to
                </div>
                <div className="text-sm font-medium text-slate-900" style={{
                fontFamily: 'system-ui, -apple-system, sans-serif'
              }} data-id="element-1604" data-mp="2ohkcl1xhmz31">
                  AI + Design roles
                </div>
              </div>
            </div>
          </div>

          {/* Right column with text */}
          <div className="lg:col-span-7 flex flex-col justify-center" data-id="element-1605" data-mp="2tiq3qvbi2eag">
            <p className="text-lg sm:text-xl font-normal leading-relaxed text-slate-800 mb-8" style={{
            fontFamily: 'system-ui, -apple-system, sans-serif'
          }} data-id="element-1606" data-mp="do7njbp7l6zt">
              Right now I'm at Eli Lilly working on clinical trial data
              orchestration, helping teams find where intelligent automation
              drives real value versus where it just adds friction. Beyond that,
              I love the creative adventure of a project and telling stories
              through the work. You have to enjoy the journey, and I love
              jumping into a fresh set of problems. The harder the challenge,
              the better.
            </p>

            <p className="text-base sm:text-lg text-slate-600 leading-relaxed max-w-prose mb-6 sm:mb-8" style={{
            fontFamily: 'system-ui, -apple-system, sans-serif'
          }} data-id="element-1607" data-mp="2efq5gbimy3j1">
              When I'm not working, I play soccer whenever I can and love
              teaching my son about the world and spending time outdoors with
              the family.
            </p>
          </div>
        </div>
      </div>
    </section>;
}